import { render, staticRenderFns } from "./SystemPageList.vue?vue&type=template&id=14ec588e"
import script from "./SystemPageList.vue?vue&type=script&lang=js"
export * from "./SystemPageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Dev\\WorldManager\\src\\WorldManager.Web\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14ec588e')) {
      api.createRecord('14ec588e', component.options)
    } else {
      api.reload('14ec588e', component.options)
    }
    module.hot.accept("./SystemPageList.vue?vue&type=template&id=14ec588e", function () {
      api.rerender('14ec588e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/systemPage/SystemPageList.vue"
export default component.exports